import css from 'styled-jsx/css';
import { colors } from 'components/styles/variables';

/* istanbul ignore next */
const liCSS = css`
  li {
    padding: 18px 16px;
    height: 56px;
    list-style: none;
    line-height: 20px;
    letter-spacing: 0.2px;
    text-align: left;
    border-bottom: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: ${colors.BLACK};
    position: relative;
  }

  li:hover,
  li.--selected {
    background-color: ${colors.G1};
  }
`;

export default liCSS;
